import CliniquesFormSection from './CliniquesFormSection';

export default CliniquesFormSection;
